// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab29b8a8","239":"925253f0","553":"0647a386"}[chunkId] + ".chunk.js";
};